// extracted by mini-css-extract-plugin
export default {"study":"study-form_study__wdws5","row":"study-form_row__0lXwM","containerField":"study-form_containerField__gHhB0","checkbox":"study-form_checkbox__xEWhE"};